import process from "process";

const isProduction: boolean = process.env.NODE_ENV === "production";

export default function isProd(): boolean {
  return isProduction;
}
